<template>
  <div class="row">
      <div class="flex xs12 product">
        <va-card>
          <form>
            <div class="row mb-4">
              <div class="flex md6 xs12">
                <p class="display-1">{{$t(editing ? 'catalog.product.edit' : 'catalog.product.new')}}</p>
              </div>
              <div class="flex md6 xs12" :style="{textAlign:'right'}">
                <va-button icon="va-icon fa fa-save" @click.prevent="save"> {{ $t('catalog.product.saveProduct') }}</va-button>
              </div>
            </div>
            <div class="row">
              <div class="flex md9 sm12">
                <div class="row">
                  <div class="flex md6 sm12">
                    <va-input
                      v-model="fields.title.value"
                      :placeholder="$t('catalog.product.title')"
                      :label="$t('catalog.product.title')"
                      :error="fields.title.error"
                    />
                  </div>
                  <div class="flex md6 sm12">
                    <va-input
                      v-model="fields.slug.value"
                      :placeholder="$t('catalog.product.slug')"
                      :label="$t('catalog.product.slug')"
                      :disabled="editing"
                      :error="fields.slug.error"
                    />
                  </div>
                  <div class="flex md12">
                    <p class="display-5 mb-3">{{$t('catalog.product.description')}}</p>
                    <va-medium-editor @initialized="handleEditorInitialization" :editorOptions="editorOptions"></va-medium-editor>
                  </div>
                </div>
                <div class="row">
                  <div class="flex md12">
                      <p class="display-5 mb-3">{{$t('catalog.product.technicalDetails')}}</p>
                  </div>
                  <div class="flex md11 sm12">
                    <div class="row">
                        <div class="flex md3">
                          <va-input
                            v-model="fields.technical.width.value"
                            :placeholder="$t('catalog.product.width')"
                            :label="$t('catalog.product.width')"
                            :error="fields.technical.width.error"
                          />
                        </div>
                        <div class="flex md3">
                          <va-input
                            v-model="fields.technical.height.value"
                            :placeholder="$t('catalog.product.height')"
                            :label="$t('catalog.product.height')"
                            :error="fields.technical.height.error"
                          />
                        </div>
                        <div class="flex md3">
                          <va-input
                            v-model="fields.technical.depth.value"
                            :placeholder="$t('catalog.product.depth')"
                            :label="$t('catalog.product.depth')"
                            :error="fields.technical.depth.error"
                          />
                        </div>
                    </div>
                    <div class="row">
                        <div class="flex md3">
                          <va-input
                            v-model="fields.technical.weight.value"
                            :placeholder="$t('catalog.product.weight')"
                            :label="$t('catalog.product.weight')"
                            :error="fields.technical.weight.error"
                          />
                        </div>
                        <div class="flex md3">
                          <va-input
                            v-model="fields.technical.volume.value"
                            :placeholder="$t('catalog.product.volume')"
                            :label="$t('catalog.product.volume')"
                            :error="fields.technical.volume.error"
                          />
                        </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="flex md12">
                      <p class="display-5 mb-3">{{$t('catalog.product.prices')}}</p>
                      <prices :prices="fields.prices.value" :vat="fields.tax.value ? fields.tax.value : 0" @removePrice="handleRemovedPrice"/>
                  </div>
                </div>
              </div>
              <div class="flex md3 sm12 pa-0">
                <va-card>
                  <div class="row">
                    <div class="flex md12 pt-1">
                      <multiSelectCategory :selected="fields.categories.selectedValues" v-model="fields.categories.value" />
                    </div>
                    <div class="flex md12">
                      <va-input
                        v-model="fields.ean.value"
                        :placeholder="$t('catalog.product.ean')"
                        :label="$t('catalog.product.ean')"
                        :error="fields.ean.error"
                      />
                    </div>
                    <div class="flex md12">
                      <va-input v-model="fields.tax.value" type="number" :label="$t('catalog.product.vat')"></va-input>
                    </div>
                    <div class="flex md12">
                      <va-input v-model="fields.stock_quantity.value" disabled type="number" :label="$t('catalog.product.stocks_quantity')"></va-input>
                    </div>
                    <div class="flex md12">
                      <va-input 
                        v-model="fields.modula_product_article.value"  
                        :label="$t('catalog.product.modula_article')"></va-input>
                    </div>
                    <div class="flex xs12">
                      <va-toggle
                        v-model="fields.status.published"
                        small
                        :label="$t('catalog.product.publish')"
                      />
                    </div>
                    <div class="flex xs12">
                      <va-toggle
                        v-model="fields.available_for_shipping.value"
                        small
                        :label="$t('catalog.product.available_for_shipping')"
                      />
                    </div>
                  </div>
                </va-card>
              </div>
            </div>
            <div class="row">
              <div class="flex md12">
                <vaFileUpload type="gallery" dropzone v-model="fields.images.value" file-types=".jpg,.jpeg" @removeFile="handleRemovedImages" @reorderImages="reordeImages = true" />
              </div>
            </div>
            <div class="row">
              <div class="flex xs12">
                <va-button icon="va-icon fa fa-long-arrow-left" color="gray" :to="{ name: 'products' }"> {{ $t('catalog.product.backToProducts') }}</va-button>
                <va-button icon="va-icon fa fa-save" @click.prevent="save"> {{ $t('catalog.product.saveProduct') }}</va-button>
                <va-button icon="va-icon fa fa-save" outline @click.prevent="saveClose"> {{ $t('catalog.product.saveCloseProduct') }}</va-button>
              </div>
            </div>
          </form>
          <div class="flex-center loader" :class="['flex-center','loader',{loading:loading}]">
              <spring-spinner
                  :animation-duration="2000"
                  :size="60"
                  :color="$themes.primary"
              />
          </div>
        </va-card>
      </div>
  </div>
</template>

<script>
import multiSelectCategory from './subComponents/multiSelectCategory';
import prices from './subComponents/prices';
import slugify from 'slugify';
import { SpringSpinner } from 'epic-spinners';
import vaFileUpload from '../../system/va-file-upload/VaFileUpload.vue'
export default {
  data(){
    return{
      loading: true,
      reordeImages: false,
      fields : {
          title: {value: null, error: false, required: true},
          slug: {value: null, error: false, required: true},
          ean: {value: null, error: false, required: false},
          categories : {value: [], error: false, required: false, selectedValues: null},
          description: {value: null, error: false, required: false},
          tax: {value: 22, error: false, required: false},
          status: {value: false, error: false, required: false, published: false},
          available_for_shipping: {value: true , error : false, required: false},
          images : {value: [], uuids: [], removed: [], error: false, required: false},
          prices : {value: [], removed:[], error: false, required: false},
          technical : {
            width: {value: null, error: false, required: false},
            height: {value: null, error: false, required: false},
            depth: {value: null, error: false, required: false},
            weight: {value: null, error: false, required: false},
            volume: {value: null, error: false, required: false}
          },
          stocks:  {value: null, error: false, required: false},
          stock_quantity: {value: null, error: false, required: false},
          modula_product_article:  {value: null, error: false, required: false},
        },
        editorOptions: {
          buttonLabels: 'fontawesome',
          autoLink: false,
          toolbar: {
              buttons: ["bold","italic","underline","anchor","h1","h2","h3"]
            }
        }
    }
  },
  components : {
    multiSelectCategory,
    SpringSpinner,
    vaFileUpload,
    prices
  },
  created(){
    if(this.editing != 0){
      this.getProduct();
    }else{
      this.loading = false;
    }
  },
  computed:{
    editing(){
      return this.$route.params.uuid != 0;
    },
    title(){
      return this.fields.title.value;
    },
    slug(){
      return this.fields.slug.value;
    },
    categories(){
      return this.fields.categories.value;
    },
    description(){
      return this.fields.description.value;
    }
  },
  watch:{
    title(t,f){
      if(!this.editing) this.fields.slug.value = slugify(t,{lower: true,strict:true});
    },
    slug(t,f){
      if(!this.editing) this.fields.slug.value = slugify(t,{lower: true,strict:true});
    },
    categories(t,f){
      if(t && t.length > 0){
        var arr = [];
        for(var i in t){
          arr.push(t[i].id);
        }
        this.fields.categories.value;
      }
    },
    description(t,f){
      if(this.editor){
        this.editor.setContent(t);
      }
    }
  },
  methods: {
    getProduct(){
      this.loading = true;
      this.$axios.get('api/products/getProduct',{params:{productUuid:this.$route.params.uuid}}).then(axRes => {
        var product = axRes.data;
        this.parseProduct(product);
        this.loading = false;
      }).catch(axErr => {
        this.showToast(
          this.$t('system.genericError'),
          {
            icon:'fa-warning',
            position: 'bottom-right',
            duration: 10000,
            fullWidth: false,
            className: 'vuestic-toast error'
          },
        )
        this.loading = false;
      })
    },
    async parseProduct(product){
      for(var i in product){  
        
        if(this.fields[i]){
          switch(i){
            case 'status':
              this.fields[i].published = product[i] == 1;
              break;
            case 'available_for_shipping':
              console.log('*******')
              console.log(i, product[i], this.fields[i])
              this.fields[i].value = product[i] == 1;
              break;
            case 'categories':
              var categories = product[i];
              if(categories){
                var arr = [];
                for(var o in categories){
                  var obj = {};
                  obj.id = categories[o];
                  arr.push(obj);
                }
                this.fields[i].selectedValues = arr;
              }
              break;
            case 'images':
              this.fields[i].value = await this.parseImages(product[i] ? product[i] : []);
              break;
            case 'prices':
              this.fields[i].value = this.parsePrices(product[i] ? product[i] : []);
              break;
            case 'tax':
              this.fields[i].value = this.$normalizePrice(product[i]);
              break;
            case 'technical':
              if(product[i]){
                for(var t in product[i]){
                  if(this.fields[i][t]) this.fields[i][t].value = product[i][t];
                }
              }
              break;
            case 'stocks': 
              if(product[i]){
                this.fields['stock_quantity'].value= product[i][0].product_giac;
                this.fields['modula_product_article'].value= product[i][0].modula_product_article
              }
              break;
            default:
              this.fields[i].value = product[i];
              break;
          }
        }
      }
    },
    async parseImages(arr){
      var images = []
      for(var i in arr){
        this.fields.images.uuids.push(arr[i].uuid);
        
        
        var image = await fetch(this.$getAWSAssetUrl(arr[i].file),{header:new Headers({'Access-Control-Allow-Origin':'*','Content-Type': 'multipart/form-data'})})
          .then(async res => {
            
              var blob = await res.blob();
              const file = await new File([blob], arr[i].title, blob);
              return file
            })
          .catch(err => {
            console.log('err',err)
          })
          images.push({order: i, file:image, uuid: arr[i].uuid});
      }
      return images;
    },
    parsePrices(arr){
      var prices = [];
      for(var i in arr){
        var obj = {}
        obj.uuid = arr[i].uuid;
        obj.fields = {
            from_quantity : {value: arr[i].from_quantity, required: true, error: false},
            to_quantity : {value: arr[i].to_quantity, required: false, error: false},
            net_value : {value: this.$normalizePrice(arr[i].net_value), required: true, error: false},
            gross_value : {value: this.$normalizePrice(arr[i].gross_value), required: false, error: false}
        }
        prices.push(obj);
      }
      return prices;
    },
    handleRemovedImages(uuid){
      for(var i in this.fields.images.uuids){
        if(uuid == this.fields.images.uuids[i]){
            this.fields.images.removed.push(uuid);
            this.fields.images.uuids.splice(i, 1);
        }
      }
    },
    handleRemovedPrice(index){
      if(this.fields.prices.value[index] && this.fields.prices.value[index].uuid) this.fields.prices.removed.push(this.fields.prices.value[index].uuid);
    },
    handleEditorInitialization(editor){
      this.editor = editor;
      if(this.fields.description.value) this.editor.setContent(this.fields.description.value);
    },
    evalFields(){
      var errors = 0;
      for(var i in this.fields){
        if(this.fields[i].required){
          if(!this.fields[i].value || this.fields[i].value == ''){
            errors = errors + 1;
            this.fields[i].error = true;
          }else{
            this.fields[i].error = false;
          }
        }
        if(i == 'prices'){
          for(var o in this.fields['prices'].value){
            var fields = this.fields['prices'].value[o].fields;
            for(var k in fields){
              if(fields[k].required && (fields[k].value === null || parseFloat(fields[k].value) < 0 || fields[k].value == '') && fields[k].value !== 0){
                errors = errors + 1;
                fields[k].error = true;
              }else{
                fields[k].error = false;
              }
            }
          }
        }
      }
      return errors == 0;
    },
    save(){
      this.doSave(false);
    },
    saveClose(){
      this.doSave(true);
    },
    doSave(close){
      this.loading = true;
      this.fields.description.value = this.editor.getContent();

      var payload = {};
      if(this.evalFields()){
        if(!this.editing){
          var payload = this.createInsertPayload();
          this.createNewProduct(payload,close);
        }else{
          var payload = this.createUpdatePayload();
          this.updateProduct(payload,close);
        }
      }else{
        this.toastError('mandatoryField');
        this.loading = false;
      }
    },
    
    createInsertPayload(){
      var formData = new FormData();
      for(var i in this.fields){
        switch(i){
          case 'status':
            formData.append('status', this.fields[i].published ? 1 : 0);
            break;
          case 'categories':
            formData.append('parent', this.fields[i].value);
            break;
          case 'images':
            var images = Array.from(this.fields[i].value);
            var imagesData = [];
            for(var o in images){
                imagesData.push(images[o]);
                var image = images[o].file;
                formData.append('file', image);
            }
            formData.append('imagesData',JSON.stringify(imagesData));
            break;
          case 'tax':
            formData.append('tax', this.$dbNormalizePrice(this.fields[i].value));
            break;
          case 'prices':
            var arr = [];
            for(var k in this.fields[i].value){
              var price = this.fields[i].value[k];
              var obj = {}
              for(var j in price.fields){
                switch(j){
                  case 'from_quantity':
                  case 'to_quantity':
                    obj[j] = parseInt(price.fields[j].value);
                    break;
                  case 'net_value':
                  case 'gross_value':
                    obj[j] = this.$dbNormalizePrice(price.fields[j].value);
                    break;
                }
              }
              arr.push(obj);
            }
            formData.append('prices', JSON.stringify(arr));

            break;
            case 'technical':
              var obj = {};
              for(var t in this.fields[i]){
                obj[t] = this.fields[i][t].value;
              }
              formData.append('technical', JSON.stringify(obj));
              break;
            default :
              if(this.fields[i].value) formData.append(i, this.fields[i].value);
              break;
        }
      }
      return formData;
    },
    createNewProduct(payload,close){
      this.$axios.post('api/products/createNewProduct',payload,{'Content-Type': 'multipart/form-data' })
          .then(axRes => {
              this.loading = false;
              this.showToast(
                  this.$t('catalog.product.successCreate'),
                  {
                      icon:'fa-check',
                      position: 'bottom-right',
                      duration: 10000,
                      fullWidth: false,
                      className: 'vuestic-toast'
                  },
              )
              if(close){
                this.$router.push({name: 'products'})
              }else{
                this.$router.push('/admin/catalog/product/'+axRes.data)
              }
              
          }).catch(axErr => {
              this.loading = false;
              if(axErr.response.data == 'slugAlreadyTaken'){
                  this.toastError('slugAlreadyTaken');
                  this.fields.slug.error = true;
              } else {
                  this.toastError('creationFailed');
              }
          })
    },
    
    createUpdatePayload(){
      var formData = new FormData();

      formData.append('uuid',this.$route.params.uuid);
      for(var i in this.fields){
        switch(i){
          case 'status':
            formData.append('status', this.fields[i].published ? 1 : 0);
            break;
          case 'categories':
            //CERCO LE CATEGORIE DA RIMUOVERE
            var catsToRemove = [];
            for(var d in this.fields[i].selectedValues){
              if(!this.fields[i].value.includes(this.fields[i].selectedValues[d].id)){
                catsToRemove.push(this.fields[i].selectedValues[d].id);
              }
            }

            //CERCO LE NUOVE CATEGORIE DA INSERIRE
            var originalCats = [];
            var catsToInsert = [];

            for(var o in this.fields[i].selectedValues){
              originalCats.push(this.fields[i].selectedValues[o].id);
            }
            for(var v in this.fields[i].value){
              if(!originalCats.includes(this.fields[i].value[v])){
                catsToInsert.push(this.fields[i].value[v]);
              }
            }

            var categories = {};
            categories.parent = catsToInsert;
            categories.delete = catsToRemove;

            categories = JSON.stringify(categories);
            formData.append('parent', categories);
            break;
          case 'prices':
            var payload = {}
            var arr = [];
            for(var k in this.fields[i].value){
              var price = this.fields[i].value[k];

              var obj = {}
              if(price.uuid) obj.uuid = price.uuid;
              obj.fields = {};
              for(var j in price.fields){
                switch(j){
                  case 'from_quantity':
                  case 'to_quantity':
                    obj.fields[j] = parseInt(price.fields[j].value);
                    break;
                  case 'net_value':
                  case 'gross_value':
                    obj.fields[j] = this.$dbNormalizePrice(price.fields[j].value);
                    break;
                }
              }
              arr.push(obj);
            }
            
            payload.prices = arr;
            payload.delete = this.fields[i].removed;



            var prices = JSON.stringify(payload);
            formData.append('prices',prices);

            break;
          case 'tax':
            formData.append('tax', this.$dbNormalizePrice(this.fields[i].value));
            break;
          case 'images':
            // RECUPERO LE IMMAGINI AGGIUNTE
            if(!this.reordeImages){
              var imagesToInsert = [];
              for(var j = this.fields[i].uuids.length; j < this.fields[i].value.length; j++){
                imagesToInsert.push(this.fields[i].value[j]);
              }
              formData.append('imagesData',JSON.stringify(imagesToInsert));
              for(var j in imagesToInsert){
                formData.append('file',imagesToInsert[j].file);
              }
              formData.append('deletedFiles',this.fields[i].removed);
            }else{
              var deleteAll = [...this.fields[i].uuids,...this.fields[i].removed];
              formData.append('deletedFiles',deleteAll);

              formData.append('imagesData',JSON.stringify(this.fields[i].value));
              for(var o in this.fields[i].value){
                formData.append('file',this.fields[i].value[o].file);
              }
            }


            break;
          case 'technical':
              var obj = {};
              for(var t in this.fields[i]){
                obj[t] = this.fields[i][t].value;
              }
              formData.append('technical', JSON.stringify(obj));
              break;
              case 'available_for_shipping':
                console.log('**é*é*é*é*éé', i, this.fields[i].value)
              formData.append(i, this.fields[i].value ? 1 : 0);
                break;
            default :
            
              if(this.fields[i].value) formData.append(i, this.fields[i].value);
              break;
        }
      }
      return formData;
    },
    updateProduct(payload,close){
      this.$axios.put('api/products/updateNewProduct',payload,{'Content-Type': 'multipart/form-data' })
          .then(axRes => {
              this.loading = false;
              this.showToast(
                  this.$t('catalog.product.successUpdate'),
                  {
                      icon:'fa-check',
                      position: 'bottom-right',
                      duration: 10000,
                      fullWidth: false,
                      className: 'vuestic-toast'
                  },
              )

              if(close){
                this.$router.push({name: 'products'})
              }else{
                this.getProduct();
              }

              
          }).catch(axErr => {
              this.loading = false;
              this.toastError('updateFailed');
          })
    },
    toastError(error){
            var msg = error ? error : 'genericError';
            this.showToast(
                this.$t('catalog.product.errors.'+msg),
                {
                    icon:'fa-warning',
                    position: 'bottom-right',
                    duration: 10000,
                    fullWidth: false,
                    className: 'vuestic-toast error'
                },
            )
        },
  }

}
</script>